<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Submit Scantron'"
    :submit-button-text="'Submit'"
    :submit-modal="submitScantron"
    :reset-modal="resetModal"
  >
    <b-row>
      <b-col>
        <p class="tsny_text">
          Clicking the 'Submit' button will submit your scantron for instant
          grading. Please double check to make sure all your answers are
          correctly entered as you will not be able to make changes once the
          exam is scored.
        </p>
      </b-col>
    </b-row>
    <b-row v-if="submitError">
      <b-col>
        <p class="tsny_status-text">
          An error occurred submitting your scantron. Please try again. If the
          issue persists, please contact your tutor
        </p>
      </b-col>
    </b-row>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import { mapActions } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
export default {
  name: "SubmitScantronModal",
  components: { TsnyModal },
  props: {
    relationshipId: {
      type: String,
      default: null
    },
    courseId: {
      type: String,
      default: null
    },
    scantron: {
      type: Object,
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  data: () => ({
    modalId: "submitScantronModal",
    submitError: false
  }),
  methods: {
    resetModal() {
      this.submitError = false;
    },
    ...mapActions({
      vuexSubmitExam: StoreConstants.ACTIONS.SUBMIT_EXAM
    }),
    async submitScantron(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this;
      $comp.submitError = false;

      try {
        let scoreReport = await $comp.vuexSubmitExam({
          _id: $comp.relationshipId,
          courseId: $comp.courseId,
          scantron: $comp.scantron
        });
        scoreReport.color = $comp.color;
        $comp.$bvModal.hide($comp.modalId);
        $comp.$router.push({
          name: "ScoreReport",
          params: {
            scoreReport: {
              ...scoreReport,
              courseId: $comp.courseId
            }
          }
        });
      } catch (error) {
        $comp.submitError = true;
        console.log(error);
      }
    }
  }
};
</script>

<style scoped></style>
